import {NgModule} from '@angular/core';
import {AutoHeightDirective} from './interfaces/directives/auto-height-element.directive';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {DashboardLayoutModule} from '@syncfusion/ej2-angular-layouts';
import {FirstUppercasePipe} from './interfaces/pipes/first-uppercase.pipe';
import {ApplicationNamePipe} from './interfaces/pipes/application-name.pipe';
import {FoundationDirective} from './interfaces/directives/foundation.directive';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatSortModule} from '@angular/material/sort';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatInputModule} from '@angular/material/input';
import {ChartModule} from 'angular-highcharts';
import {EllipsisWithTooltipDirective} from './interfaces/directives/ellipsis-with-tooltip.directive';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SalutationPipe} from './interfaces/pipes/salutation.pipe';
import {MatOptionModule} from '@angular/material/core';
import {MatStepperModule} from '@angular/material/stepper';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {EnumToArrayPipe} from './interfaces/pipes/enum-to-array.pipe';
import {MatTableModule} from '@angular/material/table';
import {SafeHtmlPipe} from './interfaces/pipes/safe-html-pipe';
import {FirstWordsLetterToUppercasePipe} from './interfaces/pipes/first-words-letter-to-uppercase.pipe';
import {LibcastUrlPipe} from './interfaces/pipes/libcast-url.pipe';
import {SortByOrderPipe} from './interfaces/pipes/sort-by-order.pipe';
import {SortByFieldPipe} from './interfaces/pipes/sort-by-field.pipe';

@NgModule({
            declarations: [
              SalutationPipe,
              SafeHtmlPipe,
              FirstUppercasePipe,
              LibcastUrlPipe,
              ApplicationNamePipe,
              EnumToArrayPipe,
              FirstWordsLetterToUppercasePipe,
              SortByOrderPipe,
              SortByFieldPipe,
              AutoHeightDirective,
              FoundationDirective,
              EllipsisWithTooltipDirective
            ],
            imports: [
              FormsModule,
              CommonModule,
              ReactiveFormsModule,
              NgSelectModule,
              DashboardLayoutModule,
              MatButtonModule,
              MatDialogModule,
              MatSortModule,
              MatFormFieldModule,
              MatDatepickerModule,
              MatMomentDateModule,
              MatInputModule,
              ChartModule,
              BrowserModule,
              AppRoutingModule,
              HttpClientModule,
              BrowserAnimationsModule,
              MatOptionModule,
              MatStepperModule,
              MatSnackBarModule,
              MatCheckboxModule,
              MatSelectModule,
              MatTableModule
            ],
            exports: [
              SalutationPipe,
              SafeHtmlPipe,
              FirstUppercasePipe,
              LibcastUrlPipe,
              ApplicationNamePipe,
              EnumToArrayPipe,
              FirstWordsLetterToUppercasePipe,
              SortByOrderPipe,
              SortByFieldPipe,
              AutoHeightDirective,
              FoundationDirective,
              EllipsisWithTooltipDirective,
              FormsModule,
              CommonModule,
              ReactiveFormsModule,
              NgSelectModule,
              DashboardLayoutModule,
              MatButtonModule,
              MatDialogModule,
              MatSortModule,
              MatFormFieldModule,
              MatDatepickerModule,
              MatMomentDateModule,
              MatInputModule,
              MatOptionModule,
              MatStepperModule,
              MatSnackBarModule,
              MatCheckboxModule,
              MatSelectModule,
              MatTableModule,
              ChartModule,
              BrowserModule,
              AppRoutingModule,
              HttpClientModule,
              BrowserAnimationsModule
            ],
            providers: [
              ApplicationNamePipe,
              SalutationPipe,
              DatePipe,
              FirstWordsLetterToUppercasePipe,
              SortByOrderPipe,
              SortByFieldPipe
            ]
          })
export class SharedModule {
}
